export const VENDORS = {
    OPERA   : "opera",
    FIREFOX : "firefox",
    SAFARI  : "safari",
    IE      : "ie",
    EDGE    : "edge",
    CHROME  : "chrome",
    BLINK   : "blink",
    CHROMEHEADLESS : "chrome-headless"
}

export const STATUS = {
    BLANK: 0,
    LOADED: 100,
    SHOWN: 150,
    READY: 200,
    STOPPED: 250,
    PAUSED: 275,
    STARTED: 300,
}

export const PAGETYPES  = {
    LONGPAGE    : "longpage",
    FULLSCREEN  : "fullscreen",
    ZOOM        : "zoom",
    STATICSIZE  : "static-size",
}

const CONSTANTS = {
    /**
     * Constants for Element/spread events
     */
    EVENT_ELEMENT_ACTION : "element_action.maglr",
    EVENT_WAIT_FOR_CHILD_ANIMATION : "wait-for-child-close.maglr",
    EVENT_BEFORE_INIT : "before-init.maglr",
    EVENT_AFTER_INIT : "after-init.maglr",
    EVENT_BEFORE_SHOW : "before-show.maglr",
    EVENT_AFTER_SHOW : "after-show.maglr",
    EVENT_AFTER_RESIZE : "after-resize.maglr",
    ANIMATION_DONE_EVENT : "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",
    EVENT_AFTER_ANIMATION_INIT : "after-animation-init.maglr",

    /* Spread statuses to keep track of the status in JS */
    STATUS,

    ERRORS : {
        NO_SCENES : "no_scenes",
        NOT_VISIBLE : "not_visible",
    },

    /* Listing of vendor constants for the browser detection */
    VENDORS,

    PAGETYPES,

    EVENTS : {
        WINDOW_SIZE_CHANGED : "window_size_changed",
        BEFORE_RESIZE       : "before_resize",
        RESIZE_DONE         : "resize_done",
        LAYOUT_CHANGED      : "layout_changed",
        AUDIO_STATE_CHANGED : "audio_state_changed",
        VIDEO_STATE_CHANGED : "video_state_changed",
    },

    EMBEDTYPES : {
        FULLHEIGHT :"fullHeight",
        STATIC :"static",
    },

    KEYS : {
        TAB : 'Tab',
        ENTER : 'Enter',
        ESC : 'Esc',
        SPACE : ' ',
        CODES : {
            TAB : 9,
            ENTER : 13,
            ESC : 27,
            SPACE : 32
        }
    }

}
export default CONSTANTS
